module.exports = __webpack_public_path__ + "daa084d417bb78771d6c322943ab58fd.svg";